import { LAST_UPDATED_DATE, DELETED } from 'constants/constant';
import actionTypes from 'redux/actionTypes';

const initialState = {
	reportsList: [],
	sharedList: [],
	dashboardLoading: false,
	isInProgress: false,
	isLargeDownload: false,
	dashboardErrorCode: 0,
	shareReportErrorCode: 0,
	isEditEnabled: false,
	editData: {},
	tabValue: 'Projects',
	userList: [],
	catmanUserList: [],
	userListLoading: true,
	userListErrorCode: 0,
	merchantUserList: [],
	dvUserList: [],
	invitedUsers: [],
	usersWithReportAccess: [],
	usersToRemoveAccess: [],
	isSharingEnabled: true,
	merchUserListLoading: true,
	dvUserListLoading: true,
	merchantUserListErrorCode: 0,
	dvUserListErrorCode: 0,
	reportTypeTabValue: 0, // Order of the tabs are Active, Saved.
	savedReportsList: [],
	draftNames: [],
	reportListFilterValues: {},
	action: null,
	reportNameList: [],
	runNowErrorCode: 0,
	searchTxt: '',
	_sortBy: LAST_UPDATED_DATE,
	_sortDirection: 'desc',
	filterBy: {},
	sharedReportTabValue: 0, // 0 for shared reports and 1 for shared recipe
	calendarRollDim: []
};

const dashboardReducer = (state = initialState, action = {}) => {
	switch (action.type) {
		case actionTypes.GET_REPORTS_LIST:
			return {
				...state,
				dashboardLoading: true,
				runNowErrorCode: 0
			};
		case actionTypes.GET_REPORTS_LIST_SUCCESS: {
			const { reportsList = [], reportNameList = [] } = action.payload;
			return {
				...state,
				dashboardLoading: false,
				dashboardErrorCode: 0,
				reportsList: reportsList,
				reportNameList: reportNameList
			};
		}
		case actionTypes.GET_REPORTS_LIST_FAILURE:
			return {
				...state,
				dashboardLoading: false,
				dashboardErrorCode: action.payload
			};
		case actionTypes.GET_SHARED_REPORTS_LIST:
			return {
				...state,
				dashboardLoading: true,
				refresh: false
			};
		case actionTypes.GET_SHARED_REPORTS_LIST_SUCCESS: {
			const { sharedList = [] } = action.payload;
			return {
				...state,
				dashboardLoading: false,
				shareReportErrorCode: 0,
				refresh: false,
				sharedList: sharedList
			};
		}
		case actionTypes.GET_SHARED_REPORTS_LIST_FAILURE:
			return {
				...state,
				dashboardLoading: false,
				shareReportErrorCode: action.payload,
				refresh: false
			};
		case actionTypes.DOWNLOAD_REPORT:
			return {
				...state,
				isInProgress: true
			};
		case actionTypes.DOWNLOAD_LARGE_REPORT:
			return {
				...state,
				isLargeDownload: true
			};
		case actionTypes.DELETE_REPORT:
			return {
				...state,
				dashboardLoading: true
			};
		case actionTypes.DELETE_REPORT_SUCCESS:
			return {
				...state,
				isInProgress: false,
				dashboardErrorCode: 0,
				dashboardLoading: false,
				reportsList: state.reportsList.filter((item) => {
					let val;
					if (action.payload.status !== DELETED && item.reportId === action.payload.reportId) {
						val = action.payload;
					}
					if (item.reportId !== action.payload.reportId) {
						val = item;
					}
					return val;
				})
			};
		case actionTypes.DOWNLOAD_REPORT_SUCCESS:
			return {
				...state,
				isInProgress: false,
				dashboardErrorCode: 0
			};
		case actionTypes.DOWNLOAD_LARGE_REPORT_SUCCESS:
			return {
				...state,
				isLargeDownload: false,
				dashboardErrorCode: 0
			};
		case actionTypes.DELETE_REPORT_FAILURE:
			return {
				...state,
				dashboardErrorCode: action.payload,
				dashboardLoading: false
			};
		case actionTypes.DOWNLOAD_REPORT_FAILURE:
			return {
				...state,
				isInProgress: false,
				dashboardErrorCode: action.payload
			};
		case actionTypes.DOWNLOAD_LARGE_REPORT_FAILURE:
			return {
				...state,
				isLargeDownload: false,
				dashboardErrorCode: action.payload
			};

		case actionTypes.REFRESH_REPORTS_LIST_SUCCESS:
			return {
				...state,
				reportsList: action.payload,
				dashboardErrorCode: 0,
				shareReportErrorCode: 0,
				isSharingEnabled: true
			};
		case actionTypes.INITIATE_RUN_NOW:
			return {
				...state,
				runNowErrorCode: 0
			};
		case actionTypes.INITIATE_RUN_NOW_FAILURE:
			return {
				...state,
				runNowErrorCode: action.payload
			};
		case actionTypes.REFRESH_REPORTS_LIST_FAILURE:
			return {
				...state,
				dashboardErrorCode: action.payload
			};
		case actionTypes.SET_USERS_WITH_REPORT_ACCESS_FAILURE:
		case actionTypes.REMOVE_REPORT_ACCESS_FAILURE:
		case actionTypes.LEAVE_REPORT_FAILURE:
			return {
				...state,
				shareReportErrorCode: action.payload,
				isSharingEnabled: true
			};
		case actionTypes.INITIATE_RUN_NOW_SUCCESS: {
			return {
				...state,
				runNowErrorCode: 0,
				reportsList: state.reportsList.map((item) => {
					let val;
					if (item.reportId === action.payload.reportId) {
						val = action.payload;
					} else {
						val = item;
					}
					return val;
				})
			};
		}
		case actionTypes.EDIT_REPORT:
			return {
				...state,
				editData: action.payload.editData,
				isEditEnabled: action.payload.isEditEnabled,
				action: action.payload.action || null
			};
		case actionTypes.SET_TAB_VALUE:
			return {
				...state,
				tabValue: action.payload
			};
		case actionTypes.SET_USERS_WITH_REPORT_ACCESS:
		case actionTypes.REMOVE_REPORT_ACCESS:
		case actionTypes.LEAVE_REPORT: {
			return {
				...state,
				isSharingEnabled: false
			};
		}
		case actionTypes.LEAVE_REPORT_SUCCESS:
			return {
				...state,
				isSharingEnabled: true
			};
		case actionTypes.GET_USER_LIST:
			return {
				...state,
				userListLoading: true,
				userList: [],
				userListErrorCode: 0
			};
		case actionTypes.GET_USER_LIST_SUCCESS:
			return {
				...state,
				userList: action.payload ? action.payload.filter((item) => !item.isCatmanUser) : [],
				catmanUserList: action.payload ? action.payload.filter((item) => item.isCatmanUser) : [],
				userListLoading: false
			};
		case actionTypes.GET_USER_LIST_FAILURE:
			return {
				...state,
				userListErrorCode: action.payload,
				isSharingEnabled: true,
				userListLoading: false
			};
		case actionTypes.RESET_USERS_WITH_REPORT_ACCESS:
			return {
				...state,
				shareReportErrorCode: 0,
				invitedUsers: [],
				usersToRemoveAccess: [],
				usersWithReportAccess: [],
				userList: [],
				merchantUserList: [],
				dvUserList: [],
				userListLoading: true,
				merchUserListLoading: true,
				dvUserListLoading: true
			};
		case actionTypes.SET_INVITED_USERS:
			return {
				...state,
				invitedUsers: action.payload ? action.payload : []
			};
		case actionTypes.SET_USERS_WITH_REPORT_ACCESS_SUCCESS:
			return {
				...state,
				usersWithReportAccess: action.payload ? action.payload : []
			};
		case actionTypes.SET_USERS_TO_REMOVE_ACCESS:
			return {
				...state,
				usersToRemoveAccess: action.payload ? action.payload : []
			};
		case actionTypes.GET_MERCHANT_USER_LIST: {
			return {
				...state,
				merchUserListLoading: true,
				merchantUserList: [],
				merchantUserListErrorCode: 0
			};
		}
		case actionTypes.GET_DV_USER_LIST: {
			return {
				...state,
				dvUserListLoading: true,
				dvUserList: [],
				dvUserListErrorCode: 0
			};
		}
		case actionTypes.GET_MERCHANT_USER_LIST_SUCCESS: {
			return {
				...state,
				merchantUserList: action.payload ? action.payload : [],
				merchUserListLoading: false
			};
		}
		case actionTypes.GET_DV_USER_LIST_SUCCESS: {
			return {
				...state,
				dvUserList: action.payload ? action.payload : [],
				dvUserListLoading: false
			};
		}
		case actionTypes.GET_MERCHANT_USER_LIST_FAILURE:
			return {
				...state,
				merchantUserListErrorCode: action.payload,
				isSharingEnabled: true,
				merchUserListLoading: false
			};
		case actionTypes.GET_DV_USER_LIST_FAILURE:
			return {
				...state,
				dvUserListErrorCode: action.payload,
				isSharingEnabled: true,
				dvUserListLoading: false
			};
		case actionTypes.SET_REPORT_TYPE_TAB_VALUE:
			return {
				...state,
				reportTypeTabValue: action.payload
			};
		case actionTypes.GET_SAVED_REPORTS_LIST:
			return {
				...state
			};
		case actionTypes.GET_SAVED_REPORTS_LIST_SUCCESS:
			return {
				...state,
				savedReportsList: action.payload
			};
		case actionTypes.GET_SAVED_REPORTS_LIST_FAILURE:
			return {
				...state,
				savedReportsList: []
			};

		case actionTypes.UPDATE_SAVED_REPORTS_LIST: {
			const idx = state.savedReportsList.findIndex(
				(item) => item.draftId === action.payload.draftId
			);

			if (idx === -1) {
				return {
					...state,
					savedReportsList: [action.payload, ...state.savedReportsList]
				};
			}
			state.savedReportsList.splice(idx, 1);
			return {
				...state,
				savedReportsList: [action.payload, ...state.savedReportsList]
			};
		}

		case actionTypes.SET_REPORT_LIST_FILTER_VALUES:
			return {
				...state,
				reportListFilterValues: { ...state.reportListFilterValues, ...action.payload }
			};

		case actionTypes.SEARCH_TXT:
			return {
				...state,
				searchTxt: action.payload
			};
		case actionTypes.SORTBY:
			return {
				...state,
				_sortBy: action.payload
			};
		case actionTypes.SORT_DIRECTION:
			return {
				...state,
				_sortDirection: action.payload === 'asc' ? 'desc' : 'asc'
			};
		case actionTypes.FILTER_BY:
			return {
				...state,
				filterBy: action.payload
			};
		case actionTypes.RESET_DASHBOARD_FILTER:
			return {
				...state,
				searchTxt: '',
				_sortBy: LAST_UPDATED_DATE,
				_sortDirection: 'desc',
				filterBy: {}
			};
		case actionTypes.SET_SHARED_TAB_VALUE:
			return {
				...state,
				sharedReportTabValue: action.payload
			};
		case actionTypes.GET_START_AND_END_DATES_SUCCESS:
			return {
				...state,
				calendarRollDim: action.payload
			};
		case actionTypes.GET_START_AND_END_DATES_FAILURE:
			return {
				...state,
				calendarRollDim: []
			};
		default:
			return state;
	}
};

export default dashboardReducer;
